module.exports = __webpack_public_path__ + "static/media/logoscreen1.fb777547.pdf";